import { render, staticRenderFns } from "./result_union.vue?vue&type=template&id=725575aa&scoped=true"
import script from "./result_union.vue?vue&type=script&lang=js"
export * from "./result_union.vue?vue&type=script&lang=js"
import style0 from "./result_union.vue?vue&type=style&index=0&id=725575aa&prod&lang=scss&scoped=true"
import style1 from "./result_union.vue?vue&type=style&index=1&id=725575aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725575aa",
  null
  
)

export default component.exports